// Aviso de lo que Promociones soltó al cambiar la forma de pago; «Seguir» lleva al paso siguiente.
import { Button } from '@/kit';
import type { DroppedPromotions } from '../api/usePaymentMethodChange';
import { WizardWarningNotice } from './WizardWarningNotice';

export function DroppedPromotionsNotice({
    dropped,
    onContinue,
}: {
    dropped: DroppedPromotions;
    onContinue: () => void;
}) {
    return (
        <WizardWarningNotice
            action={
                <Button size="sm" variant="secondary" onClick={onContinue}>
                    Seguir
                </Button>
            }
        >
            {dropped.notices.map((notice, index) => (
                <p key={index}>{notice}</p>
            ))}
        </WizardWarningNotice>
    );
}
